export const NAVIGATE_EVENT = 'page-navigate';

export interface NavigateEvent {
  url: string;
  previous: string | null;
}

export const CLICK_EVENT = 'click';

export interface ClickEvent {
  trigger: string;
  data: object;
}

export type UserActivityEvent = NavigateEvent | ClickEvent;
